import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import styles from './schedulePO.module.css';
import { Back } from '../../../Svg';
import { useNavigate } from 'react-router-dom';
import { getAllScheduleProductThunk, uploadschedulepoThunk } from '../../redux/ScheduleSlice';
import { useDispatch, useSelector } from 'react-redux';
import DeliveryAddressPopup from '../../../Dashboard/CustomerDash/Components/allEnquiresTab/SelectAddress';

const SchedulePO = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { scheduleData, refresh } = useSelector((state) => state.schedule);
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [open, setOpen] = useState(false);

    // Fetch schedule data
    useEffect(() => {
        dispatch(getAllScheduleProductThunk());
    }, [refresh]);

    // Formik setup
    const formik = useFormik({
        initialValues: {
            products: [],
            purchaseOrderUri: '',
            period: '',
            scheduleDate: '',
            remarks: '',
        },
        validationSchema: Yup.object({
            period: Yup.number()
                .positive('Period must be a positive number')
                .required('Period is required'),
            scheduleDate: Yup.date()
                .typeError('Invalid date format')
                .required('Schedule Date is required'),
            remarks: Yup.string(),
        }),
        onSubmit: async (values) => {
            setOpen(true)
        },
    });



    const handleSaveSelection = async () => {
        const day = new Date(formik.values.scheduleDate).getDate();
        const formData = {
            ...formik.values,
            scheduleDate: day,
            shippingAddress: selectedAddress
        };

        const status = await dispatch(uploadschedulepoThunk(formData))

        if (status?.payload === 200) {
            navigate('/scheduleCart')
        }

    };

    // Populate product data
    useEffect(() => {
        if (scheduleData?.length) {
            const products = scheduleData.map((item) => ({
                productId: item.productId,
                quantity: item.quantity,
                totalQty: item.totalQty,
            }));
            formik.setFieldValue('products', products);
        }
    }, [scheduleData]);

    return (
        <>
            <div className={styles.imgBread}>
                <div className={styles.breadContent}>
                    <h1 className={styles.breadTitle}>Schedule PO Form</h1>
                    <p className={styles.breadSubtitle}>
                        Plan recurring deliveries for the parts in your schedule cart.
                    </p>
                </div>
            </div>
            <div className={styles.formSection}>
                <div className={styles.formWrap}>
                <div>
                    <button className={styles.compBtn} onClick={() => navigate(-1)}>
                        <Back />
                        Back to previous page
                    </button>
                </div>
                <form onSubmit={formik.handleSubmit} className={styles.card}>
                    <div className={styles.formHeader}>
                        <span className={styles.headerIcon}>
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                <rect x="3" y="4" width="18" height="18" rx="2" />
                                <line x1="16" y1="2" x2="16" y2="6" />
                                <line x1="8" y1="2" x2="8" y2="6" />
                                <line x1="3" y1="10" x2="21" y2="10" />
                            </svg>
                        </span>
                        <div className={styles.headerText}>
                            <h2 className={styles.addCatH2}>
                                Fill the below details
                            </h2>
                            <p className={styles.formSubtext}>
                                Set how long and from which date your order should be scheduled.
                            </p>
                        </div>
                        {scheduleData?.length > 0 && (
                            <span className={styles.itemsPill}>
                                {scheduleData.length} {scheduleData.length === 1 ? 'item' : 'items'}
                            </span>
                        )}
                    </div>
                    <div className={styles.qrForminputs} >
                        <label className={styles.addCatLabel} >
                            Months Period
                            <div className={styles.inputSuffixWrap}>
                                <input
                                    type="number"
                                    name="period"
                                    min="1"
                                    placeholder="e.g. 3"
                                    className={styles.addCatInput}
                                    value={formik.values.period}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                                <span className={styles.inputSuffix}>months</span>
                            </div>
                            {formik.errors.period && formik.touched.period ? (
                                <div className={styles.errorText}>{formik.errors.period}</div>
                            ) : (
                                <span className={styles.fieldHint}>How many months to keep this schedule running.</span>
                            )}
                        </label>
                        <label className={styles.addCatLabel}>
                            Schedule Date
                            <input
                                type="date"
                                name="scheduleDate"
                                placeholder="Enter schedule date"
                                className={styles.addCatInput}
                                value={formik.values.scheduleDate}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            {formik.errors.scheduleDate && formik.touched.scheduleDate ? (
                                <div className={styles.errorText}>{formik.errors.scheduleDate}</div>
                            ) : (
                                <span className={styles.fieldHint}>Order is scheduled on this day of each month.</span>
                            )}
                        </label>
                        <label className={`${styles.addCatLabel} ${styles.fullWidth}`}>
                            Project Remarks <span className={styles.optional}>(optional)</span>
                            <textarea
                                name="remarks"
                                rows={3}
                                placeholder="Add any notes about this project or order"
                                className={`${styles.addCatInput} ${styles.remarksInput}`}
                                value={formik.values.remarks}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                        </label>
                    </div>
                    <div className={styles.infoNote}>
                        After you submit, you'll be asked to choose a delivery address.
                    </div>
                    <div className={styles.formActions}>
                        <button type="button" className={styles.cancelBtn} onClick={() => formik.resetForm()}>
                            Cancel
                        </button>
                        <button type="submit" className={styles.submitBtn} disabled={formik.isSubmitting}>
                            {formik.isSubmitting ? "please wait..." : "Submit"}
                        </button>
                    </div>
                </form >
                </div>
                <DeliveryAddressPopup
                    selectedAddress={selectedAddress}
                    setSelectedAddress={setSelectedAddress}
                    setOpen={setOpen}
                    open={open}
                    handleSubmit={handleSaveSelection}
                />
            </div >
        </>
    );
};

export default SchedulePO;
